module.exports = __webpack_public_path__ + "05_bob_black.2cc4242f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/05_bob_black.png
// module id = tKAJ
// module chunks = 0